<nk-root-modal></nk-root-modal>
<router-outlet *ngIf="translationsReady$ | async"></router-outlet>
<ng-container *ngIf="loadingApp">
  <nk-spinner size="lg"></nk-spinner>
</ng-container>
<nk-toastr></nk-toastr>
